import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';
import Session from 'mewe/shared/session';

export default class RegisterRoute extends Route {
  @service('storyblok') storyblok;

  beforeModel() {
    Session.isAuthenticated().then(({ isAuthenticated }) => {
      if (isAuthenticated) {
        window.location.href = '/myworld';
      }
    });
  }

  model() {
    return this.storyblok.loadStory('home-wip');
  }
}
